export const deliveryAttemptsCollectionGuard = 'GET /deliverytrackings';
export const deliveryAttemptsResourceGuard = 'GET /deliverytrackings/d+';
export const deliveryAttemptsItem = 'GET /deliverytrackings/:id';
export const deleteDeliveryAttemptsGuard = 'DELETE /deliverytrackings/d+';
